import React from 'react';
import {SkeletonBlock} from '@aboutyou/ui-components';
import styled from 'styled-components';

export const BasketFAQSkeleton = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="100%" $height="40px" />
      <SkeletonBlock $width="100%" $height="40px" />
      <SkeletonBlock $width="100%" $height="40px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
